/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Profile_Donor_DonatedInputs */

const id_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("id", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} telah menyumbangkan ${i?.count} kunci ke egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} telah menyumbangkan ${i?.count} kunci ke egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const ms_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ms", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} telah menderma ${i?.count} kunci kepada egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} telah menderma ${i?.count} kunci kepada egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const da_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("da", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} har doneret ${i?.count} nøgle til egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} har doneret ${i?.count} nøgler til egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const de_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} hat ${i?.count} Schlüssel an egdata.app gespendet`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} hat ${i?.count} Schlüssel an egdata.app gespendet`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const en_us2_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en-US", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} has donated ${i?.count} key to egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} has donated ${i?.count} keys to egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const es_es2_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-ES", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} ha donado ${i?.count} clave a egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} ha donado ${i?.count} claves a egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const es_mx2_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-MX", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} ha donado ${i?.count} llave a egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} ha donado ${i?.count} llaves a egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const fil_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fil", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Si ${i?.name} ay nag-donate ng ${i?.count} key sa egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Si ${i?.name} ay nag-donate ng ${i?.count} key sa egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const fr_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} a fait don de ${i?.count} clé à egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} a fait don de ${i?.count} clés à egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const it_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("it", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} ha donato ${i?.count} chiave a egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} ha donato ${i?.count} chiavi a egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const hu_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hu", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} adományozott ${i?.count} kulcsot az egdata.app-nak`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} adományozott ${i?.count} kulcsot az egdata.app-nak`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const nl_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} heeft ${i?.count} sleutel gedoneerd aan egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} heeft ${i?.count} sleutels gedoneerd aan egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const no_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("no", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} har donert ${i?.count} nøkkel til egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} har donert ${i?.count} nøkler til egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const pl_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} przekazał ${i?.count} klucz do egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} przekazał ${i?.count} kluczy do egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const pt_br2_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} doou a chave ${i?.count} para egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} doou chaves ${i?.count} para egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const pt_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} doou ${i?.count} chave ao egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} doou ${i?.count} chaves ao egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const ro_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ro", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} a donat ${i?.count} cheie către egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} a donat ${i?.count} chei către egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const fi_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} on lahjoittanut ${i?.count} avaimen egdata.appiin`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} on lahjoittanut ${i?.count} avainta egdata.appiin`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const sv_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("sv", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} har donerat ${i?.count} nyckel till egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} har donerat ${i?.count} nycklar till egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const vi_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("vi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} đã quyên góp ${i?.count} key cho egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} đã quyên góp ${i?.count} key cho egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const tr_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("tr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name}, egdata.app'a ${i?.count} anahtar bağışladı`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name}, egdata.app'a ${i?.count} anahtar bağışladı`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const cs_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("cs", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} daroval ${i?.count} klíč egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} daroval ${i?.count} klíčů egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const bg_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("bg", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} дари ${i?.count} ключ на egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} дари ${i?.count} ключа на egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const ru_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ru", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} пожертвовал(а) ${i?.count} ключ egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} пожертвовал(а) ${i?.count} ключей(а) egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const uk_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("uk", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} пожертвував ${i?.count} ключ до egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} пожертвував ${i?.count} ключів до egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const ar_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ar", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`تبرع ${i?.name} بمفتاح ${i?.count} إلى egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`تبرع ${i?.name} بـ ${i?.count} مفتاح إلى egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const hi_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} ने egdata.app को ${i?.count} कुंजी दान की`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} ने egdata.app को ${i?.count} कुंजियाँ दान कीं`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const th_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("th", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} บริจาค ${i?.count} คีย์ให้ egdata.app`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} บริจาค ${i?.count} คีย์ให้ egdata.app`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const ja_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} が egdata.app に ${i?.count} 個のキーを寄付しました`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} が egdata.app に ${i?.count} 個のキーを寄付しました`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const zh_cn2_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-CN", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} 已向 egdata.app 捐赠了 ${i?.count} 个Key`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} 已向 egdata.app 捐赠了 ${i?.count} 个Key`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const zh_hant1_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-Hant", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} 已向 egdata.app 捐贈了 ${i?.count} 個Key`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name} 已向 egdata.app 捐贈了 ${i?.count} 個Key`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

const ko_profile_donor_donated = /** @type {(inputs: Profile_Donor_DonatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ko", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name}님이 egdata.app에 키 ${i?.count}개를 기부했습니다`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.name}님이 egdata.app에 키 ${i?.count}개를 기부했습니다`);
	return /** @type {LocalizedString} */ ("profile.donor.donated");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{name} has donated {count} key to egdata.app" |
* | "other" | "{name} has donated {count} keys to egdata.app" |
*
* @param {Profile_Donor_DonatedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_donor_donated = /** @type {((inputs: Profile_Donor_DonatedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Donor_DonatedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_donor_donated(inputs)
	if (locale === "ms") return ms_profile_donor_donated(inputs)
	if (locale === "da") return da_profile_donor_donated(inputs)
	if (locale === "de") return de_profile_donor_donated(inputs)
	if (locale === "en-US") return en_us2_profile_donor_donated(inputs)
	if (locale === "es-ES") return es_es2_profile_donor_donated(inputs)
	if (locale === "es-MX") return es_mx2_profile_donor_donated(inputs)
	if (locale === "fil") return fil_profile_donor_donated(inputs)
	if (locale === "fr") return fr_profile_donor_donated(inputs)
	if (locale === "it") return it_profile_donor_donated(inputs)
	if (locale === "hu") return hu_profile_donor_donated(inputs)
	if (locale === "nl") return nl_profile_donor_donated(inputs)
	if (locale === "no") return no_profile_donor_donated(inputs)
	if (locale === "pl") return pl_profile_donor_donated(inputs)
	if (locale === "pt-BR") return pt_br2_profile_donor_donated(inputs)
	if (locale === "pt") return pt_profile_donor_donated(inputs)
	if (locale === "ro") return ro_profile_donor_donated(inputs)
	if (locale === "fi") return fi_profile_donor_donated(inputs)
	if (locale === "sv") return sv_profile_donor_donated(inputs)
	if (locale === "vi") return vi_profile_donor_donated(inputs)
	if (locale === "tr") return tr_profile_donor_donated(inputs)
	if (locale === "cs") return cs_profile_donor_donated(inputs)
	if (locale === "bg") return bg_profile_donor_donated(inputs)
	if (locale === "ru") return ru_profile_donor_donated(inputs)
	if (locale === "uk") return uk_profile_donor_donated(inputs)
	if (locale === "ar") return ar_profile_donor_donated(inputs)
	if (locale === "hi") return hi_profile_donor_donated(inputs)
	if (locale === "th") return th_profile_donor_donated(inputs)
	if (locale === "ja") return ja_profile_donor_donated(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_donor_donated(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_donor_donated(inputs)
	return ko_profile_donor_donated(inputs)
});
export { profile_donor_donated as "profile.donor.donated" }